import type {CreateExtArgs, DmApis, Extension, ExtensionAPI} from '@wix/document-manager-core'

export interface ValidationExtensionAPI extends ExtensionAPI {
    validation: {
        validateOpenTransactionAndReportOnly(tags?: Record<string, string>): void
        validate(): void
    }
}

const createExtensionAPI = ({dal}: CreateExtArgs): ValidationExtensionAPI => {
    const validateOpenTransactionAndReportOnly = (tags?: Record<string, string>): void => {
        try {
            dal.validatePendingCommit(tags)
        } catch (e) {
            //Ignoring, reporting only
        }
    }

    const validate = () => {
        return dal.validate(undefined, 'Pages')
    }

    return {
        validation: {
            validateOpenTransactionAndReportOnly,
            validate
        }
    }
}

const createPublicAPI = ({extensionAPI}: DmApis) => {
    const {validation} = extensionAPI as ValidationExtensionAPI
    return {
        validation: {
            validate(): void {
                return validation.validate()
            }
        }
    }
}

const createExtension = (): Extension => ({
    name: 'validation',
    createExtensionAPI,
    createPublicAPI
})

export {createExtension}
